export default {
  title: 'ใบแจ้งรายได้ออนไลน์',
  form: {
    month: {
      placeholder: 'เดือน'
    }
  },
  button: {
    forgotPassword: 'ลืมรหัสผ่าน'
  },
  table: {
    column: {
      period: 'รอบการจ่าย',
      description: 'ชื่อรายงาน'
    },
    button: {
      download: 'ดาวน์โหลดรายการที่เลือก'
    }
  },
  forgotPassword: {
    button: 'ลืมรหัสผ่านของเอกสาร',
    errors: {
      forbidden: 'คุณไม่มีสิทธิ์ส่งรหัสผ่านเอกสาร ePay กรุณาติดต่อผู้ดูแลระบบ',
      tooManyRequests: 'ส่งคำขอถี่เกินไป กรุณารอแล้วลองใหม่',
      server: 'Internal Server Error กรุณาติดต่อผู้ดูแลระบบ',
      connection: 'ไม่สามารถเชื่อมต่อระบบได้ กรุณาลองใหม่',
      failed: 'ไม่สามารถส่งรหัสผ่านเอกสาร ePay ได้ กรุณาติดต่อผู้ดูแลระบบ'
    },
    modalInfo: {
      title: 'ระบบจะส่งรหัสผ่านไปยังอีเมล ต้องการส่งหรือไม่',
      button: {
        ok: 'ยืนยัน',
        cancel: 'ยกเลิก'
      }
    },
    modalSuccess: {
      title: 'ส่งรหัสผ่านเอกสารไปยังอีเมลของคุณแล้ว',
      button: {
        ok: 'ตกลง'
      }
    }
  }
}
